import { render, staticRenderFns } from "./AboutButton.vue?vue&type=template&id=2a6500f2&scoped=true&"
import script from "./AboutButton.vue?vue&type=script&lang=js&"
export * from "./AboutButton.vue?vue&type=script&lang=js&"
import style0 from "./AboutButton.vue?vue&type=style&index=0&id=2a6500f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6500f2",
  null
  
)

export default component.exports